/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import EmptyStep from "../steps/EmptyStep";
import ProviderItem from "./ProviderItem";
import ProviderItemSkeleton from "../../skeleton/ProviderItemSkeleton";
import { useProviders } from "../../../lib/react-query/useProviders";
import { useBooking } from "../../../hooks/useBooking";
import usePluginUtils from "../../../hooks/usePluginUtils";

const ProvidersList = () => {
  const { selectedLocation, filterAllowedProviders } = useBooking();
  const { isPluginEnabled } = usePluginUtils();
  const { isLoading, data: providers } = useProviders({
    "filter[location_id]": selectedLocation?.id,
    ...(isPluginEnabled("classes") && { "filter[type]": "service" }),
  });
  const filteredProviders = providers ? filterAllowedProviders(providers) : [];

  if (isLoading) {
    return [...Array(2)].map((_, index) => <ProviderItemSkeleton key={index} />);
  }

  if (!providers.length) {
    return <EmptyStep message="No providers available" />;
  }

  return filteredProviders?.map((provider) => {
    return <ProviderItem key={provider.id} provider={provider} />;
  });
};

export default ProvidersList;
